import useWindowDimensions from 'hooks/useWindowDimensions';
import { Spinner } from 'components/loading/Spinner';
import { RowBox } from 'styles';

function FullScreenLoading() {
  const { windowInnerWidth, windowInnerHeight } = useWindowDimensions();

  return (
    <RowBox $padding="0 16px" $align="center" $justify="space-evenly" $width={windowInnerWidth} $height={windowInnerHeight}>
      <Spinner $width={50} $height={50}/>
    </RowBox>
  );
}

export default FullScreenLoading;